import axios from "@/lib/axios";

import { Thread } from "../types/thread";

export const ThreadsKeys = {
  Threads: "threads",
  Thread: (id: string) => ["thread", id],
} as const;

/**
 * Create a new thread
 */
export const createThread = async (): Promise<Thread> => {
  const response = await axios.post<Thread>("/chat/threads");
  return response.data;
};

/**
 * Get all threads for the current user
 */
export const getThreads = async (): Promise<Thread[]> => {
  const response = await axios.get<Thread[]>("/chat/threads");
  return response.data;
};

/**
 * Delete a thread
 */
export const deleteThread = async (threadId: string): Promise<void> => {
  await axios.delete(`/chat/threads/${threadId}`);
};
